<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1s demo-form-inline" ref="query" :model="query" size="small">
      	  <el-form-item style="width:19%">
		        <el-date-picker
		            v-model="query.date"
		            type="daterange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd" @change="isselect=true" clearable style="width:100%">
		        </el-date-picker>
	        </el-form-item>
          <!-- 活动状态 -->
          <!--
          <el-form-item style="width:12%">
          	  <el-select v-model="query.status" clearable filterable>
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in statuslists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          -->

          <!-- 关键字搜索类型 -->
          <!--
          <el-form-item>
          	  <el-select v-model="query.keytype" filterable>
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in keytypelists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          -->
          <!-- 关键字 -->
          <el-form-item>
              <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="danger" icon="el-icon-circle-plus-outline" @click="addoffers">添加活动</el-button>
          </el-form-item>
      </el-form>

      <!-- 活动信息小计 -->
      <div class="backborder2" style="margin-top:10px;padding:3px 1% 30px 1%;background:none;border:none">
        <div style="float:left;width:100%">
            <el-tooltip class="item" effect="dark" content="包含活动商品的商城订单数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单次数小计：{{stattotals.orders}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含活动商品的店铺数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单店铺数小计：{{stattotals.shops}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含活动商品的人数小计（已付款的订单）" placement="top">
                <span class="activetotal">下单人数小计：{{stattotals.users}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="活动商品在商城所下的订单里实际付款的金额小计（已付款的订单）" placement="top">
                <span class="activetotal">实付金额小计：{{stattotals.amounts}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="活动商品在商城所下的订单里的成本小计（已付款的订单）" placement="top">
                <span class="activetotal">成本小计：{{stattotals.costs}}</span>
            </el-tooltip>
        </div>
      </div>
      <!------------------------search end---------------------->
	  
	  <!------------------------活动信息列表----------------------->
	  <div class="backborder2 backbbtn" style="margin-top:10px">
	      <el-table :data="datalists" v-loading="listLoading">
            <el-table-column prop="id" label="id" width="50" align="center"></el-table-column>
	          <el-table-column label="活动信息">
              <template slot-scope="scope">
                <div style="float:left;width:100%" class="offertitles">
                    <span>{{scope.row.name}}</span>
                    <i class="offerstatus1" v-if="scope.row.type==1">未开始</i>
                    <i class="offerstatus2" v-if="scope.row.type==2">进行中</i>
                    <i class="offerstatus1" v-if="scope.row.type==3">已结束</i>
                    <i class="offerstatus1" v-if="scope.row.status==0" style="margin-left:10px">未开团</i>
                    <i class="offerstatus2" v-if="scope.row.status==1" style="margin-left:10px">已开团</i>
                    <el-tooltip class="item" effect="dark" :content="scope.row.reason" placement="top" v-if="scope.row.status==2">
                        <i class="offerstatus2" style="color:#fff;background:red;margin-left:10px">成团失败</i>
                    </el-tooltip>
                </div>
                <div style="float:left;width:100%" class="offermoney"><i>创建人员</i><span>{{scope.row.managername}}</span></div>
                <div style="float:left;width:100%" class="offertime"><i>创建时间</i><span>{{scope.row.inputtime}}</span></div>
                <div style="float:left;width:100%" class="offermoney"><i>活动时间</i><span>{{scope.row.starttime}}~{{scope.row.endtime}}</span></div>
              </template>
            </el-table-column>
            <el-table-column label="参团信息" align="center">
              <template slot-scope="scope">
                <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#8b572a;font-weight:bold">成团金额：{{scope.row.amount}}</span>
                <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#8b572a;font-weight:bold;">参团金额：{{scope.row.singleamount}}</span>
                <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#8b572a;font-weight:bold;margin-bottom:10px;">活动折扣：{{scope.row.limitpercent}}%</span>
                <div style="float:left;width:100%;padding:0;text-align:center">
                    <div style="float:left;border-radius:15px;width:40%;height:15px;background:#dddddd;padding:0;margin-left:15%;overflow:hidden">
                        <div class="pintuanpercent" :style="'width:'+scope.row.showpercent"></div>
                    </div>
                    <span style="float:left;width:20%;margin-left:5%;text-align:center;font-size:12px;line-height:15px;font-weight:bold;color:#8b572a;text-align:center">{{scope.row.percent}}</span>
                </div>
              </template>
            </el-table-column>
            <!--
            <el-table-column prop="brandshow" label="品牌数量" width="110" align="center"></el-table-column>
            -->
            <el-table-column prop="orders" label="成交订单数" width="110" align="center"></el-table-column>
            <el-table-column prop="shops" label="下单店铺数" width="110" align="center"></el-table-column>
            <el-table-column prop="users" label="下单人数" width="110" align="center"></el-table-column>
            <el-table-column prop="prices" label="实付金额" width="110" align="center"></el-table-column>
            <el-table-column prop="costs" label="成本" width="110" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="活动详情" placement="top">
                      <el-button type="primary" icon="el-icon-document" size="mini" circle @click="showactives(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="编辑活动" placement="top">
                      <el-button type="warning" icon="el-icon-edit" size="mini" circle  @click="editoffersnew(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="活动商品下单统计" placement="top">
                      <el-button type="warning" icon="el-icon-goods" size="mini" circle @click="getorderstats(scope.row)"></el-button>
                  </el-tooltip>
                  <!--
                  <el-tooltip class="item" effect="dark" content="设置拼团信息" placement="top" v-if="scope.row.status==0">
                      <el-button type="warning" icon="el-icon-setting" size="mini" circle @click="getpingtuansetting(scope.row)"></el-button>
                  </el-tooltip>
                  -->
                  <el-tooltip class="item" effect="dark" content="删除活动" placement="top">
                      <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deloffersnew(scope.row)"></el-button>
                  </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
    </div>


    <!-- 新增活动模块 start -->
    <el-dialog title="新增 / 编辑活动" :visible.sync="addactiveDialog" width="70%" top="10vh" :before-close="closeadd">
        <el-form class="addoffersnew">
          <el-form-item label="活动图片" label-width="110px">
              <template>
                  <div class="backborder-other" style="overflow:hidden;position:relative">
                      <ul class="imglists">
                          <li v-for="(item,index) in addActivequery.thumb" :key="index">
                              <img :src="GLOBAL.staticUrl+item" />
                              <a @click="closethumb(index)" class="thumbclose">-</a>
                          </li>
                          <li>
                              <input type="file" id="adimg" style="display:none" @change="getadimgb($event)"/>
                              <a @click="getadimga()"><img src="../../static/images/no-img.png" /></a>
                          </li>
                      </ul>
                  </div>
              </template>
          </el-form-item>
          <el-form-item label="活动名称" label-width="110px">
              <el-input v-model="addActivequery.name" size="small" style="width:40%"></el-input>
          </el-form-item>
          <el-form-item label="专区展示时间" label-width="100px">
		        <el-date-picker
                size="small"
		            v-model="addActivequery.showdate"
		            type="datetimerange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd HH:mm:ss" clearable style="width:40%">
		        </el-date-picker>
	        </el-form-item>
          <el-form-item label="活动时间" label-width="100px">
		        <el-date-picker
                size="small"
		            v-model="addActivequery.date"
		            type="datetimerange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd HH:mm:ss" clearable style="width:40%">
		        </el-date-picker>
	        </el-form-item>
          <el-form-item label="成团门槛" label-width="110px">
              <el-input v-model="addActivequery.amount" size="small" style="width:20%"><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="参团门槛" label-width="110px">
              <el-input v-model="addActivequery.singleamount" size="small" style="width:20%"><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="活动折扣" label-width="110px">
              <el-input v-model="addActivequery.limitpercent" size="small" style="width:20%"><template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item label="虚拟进度" label-width="110px">
              <el-input v-model="addActivequery.placepercent" size="small" style="width:20%"><template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item label="详情设置" label-width="110px">
		        <template slot-scope="scope">
                <!--
                <el-button size="small" type="warning" round style="float:left;" @click="settingareas">活动区域设置</el-button>
                -->
                <el-button size="small" type="primary" round style="float:left;" @click="addcontentDialog=true">详情设置</el-button>
                <el-button size="small" type="primary" round style="float:left;" @click="addshareDialog=true">分享设置</el-button>
            </template>
	        </el-form-item>
          <el-form-item label="参团品牌" label-width="110px">
              <template slot-scope="scope">
                <el-button size="small" type="danger" round style="float:left;" @click="checkgoods">新增品牌</el-button>
                <!--
                <div class="offersallsetting">
                  <p>已选 <em>{{addActivequery.brands.length}}</em> 个品牌</p>
                </div>
                <el-button size="small" type="danger" round style="float:left;margin-left:2%" @click="deladdoffersall">清空已选品牌</el-button>
                -->
              </template>
          </el-form-item>
        </el-form>
        <div class="offersnewgoods">
          <el-table :data="addActivequery.brands" v-loading="addActivequeryloading">
	          <el-table-column label="品牌图片">
              <template slot-scope="scope">
                <div class="showoffersthumb" style="float:left;width:15%;border-radius:5px;border:1px solid #dddddd;padding:2px">
                    <a style="cursor:pointer" @click="changebrandthumb(scope.row)">
                      <img :src="GLOBAL.staticUrl+scope.row.thumb" style="float:left;width:100%;border-radius:5px"/>
                      <input type="file" id="brandimg" style="display:none" @change="getadimgbrand($event)"/>
                    </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="品牌名称" prop="name" width="150" />
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deladdoffersgoods(scope.$index)"></el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addactiveDialog=false">取 消</el-button>
            <el-button size="small" type="primary" :loading="addoffersnewLoading" @click="addcreateSave">保存</el-button>
        </div>  
    </el-dialog>

    <!-- 活动详情信息设置 -->
    <el-dialog title="活动详情" :visible.sync="addcontentDialog" width="50%" top="10vh">
        <div style="display:none"><input type="file" class="addoffersfile" @change="getaddimg($event)"></div>
        <quill-editor v-model="addActivequery.content"
            ref="myQuillEditor"
			      :options="editorOption"
			      @onEditorChange="onEditorchange($event)">
  			</quill-editor>
    </el-dialog>
    <!-- 新增活动模块 end -->



    <!-- 选择品牌信息设置 -->
    <el-dialog title="选择品牌信息" :visible.sync="goodsDialog" width="60%" top="10vh">
        <!--
        <div style="float:left;width:100%;text-align:right;margin-bottom:10px">
            <el-button size="small" @click="goodsDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="addgoodssave">保存</el-button>
        </div>
        -->  
        <el-form :inline="true">
          <el-form-item>
              <el-input placeholder="请输入商品名称 / 规格名称" size="small" v-model="goodsquery.key" clearable @keyup.enter.native="getgoodsList" @change="goodsqueryischange=true" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
					    <el-button size="small" type="primary" icon="el-icon-search" circle @click="getgoodsList"></el-button>
				  </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="goodslists" v-loading="goodslistsloading" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall">
            <!--
            <el-table-column type="selection" width="50"></el-table-column>
            -->
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div style="float:left;width:50%;border-radius:5px;padding:2px;border:1px solid #dddddd">
                    <img :src="GLOBAL.staticUrl+scope.row.thumb" style="float:left;width:100%;border-radius:5px"/>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="品牌名称" prop="name" width="200" align="center"></el-table-column>
            <el-table-column label="商城是否允许展示" width="200" align="center">
              <template slot-scope="scope">
                <span style="color:#67C23A" v-if="scope.row.isshowmall==1">允许展示</span>
                <span style="color:#F56C6C" v-if="scope.row.isshowmall==0">不允许展示</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="success" size="mini" icon="el-icon-check" circle @click="addgoodssave(scope.row)" />
              </template>
            </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChoosegoodsChange"
            @current-change="pageChoosegoodsCurrentChange"
            :current-page="goodsquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="goodsquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="goods_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <!--
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="goodsDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="addgoodssave">保存</el-button>
        </div>
        -->  
    </el-dialog>
    <!-- 选择商品信息设置 end -->

    <!-- 选择商品规格信息设置 start -->
    <el-dialog title="选择商品规格信息" :visible.sync="propertyDialog" width="40%" top="10vh">
        <el-table :data="propertylists" v-loading="propertyloading">
            <el-table-column label="id" prop="id" width="90" align="center"></el-table-column>
            <el-table-column label="规格名称" prop="spec"></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-check" size="mini" circle @click="selectpropertys(scope.row)"></el-button>
              </template>
            </el-table-column>
        </el-table>
    </el-dialog>
    <!-- 选择商品规格信息设置 end -->

    <!-- 活动信息详情 start-->
    <el-dialog title="活动详情信息" :visible.sync="showoffersDialog" width="85%" top="10vh">
        <div v-loading="showoffersloaing" style="float:left;width:100%;margin-bottom:20px">
          <el-col :span="24" style="margin-bottom:10px">
              <div class="backborder-other" style="overflow:hidden;position:relative">
                  <ul class="imglists">
                      <li v-for="(item,index) in showoffersinfos.thumb" :key="index">
                          <img :src="GLOBAL.staticUrl+item" />
                      </li>
                  </ul>
              </div>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">活动名称：{{showoffersinfos.name}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">成团金额：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.amount}}</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">参团金额：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.singleamount}}</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">活动折扣：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.limitpercent}}</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">成团进度条：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.truepercent}}</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">虚拟进度条：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.placepercent}}</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">
              <div style="float:left;width:100%" class="offertitles">
                  <span>活动时间：{{showoffersinfos.time}}</span>
                  <i class="offerstatus1" v-if="showoffersinfos.type==1">未开始</i>
                  <i class="offerstatus2" v-if="showoffersinfos.type==2">进行中</i>
                  <i class="offerstatus1" v-if="showoffersinfos.type==3">已结束</i>
                  <i class="offerstatus1" v-if="showoffersinfos.status==0">未成团</i>
                  <i class="offerstatus2" v-if="showoffersinfos.status==1">已开团</i>
                  <i class="offerstatus2" style="background:red;color:#fff" v-if="showoffersinfos.status==2">成团失败</i>
              </div>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">
              <div style="float:left;width:100%" class="offertitles">
                  <span>成团失败原因：{{showoffersinfos.reason}}</span>
              </div>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">添加时间：{{showoffersinfos.inputtime}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">创建账号：{{showoffersinfos.managername}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">活动详情：
              <!--
              <el-button type="warning" size="mini" round @click="offersareasDialog=true">活动区域信息</el-button>
              -->
              <el-button type="primary" size="mini" round @click="offersnewDialog=true">活动详情信息</el-button>
              <el-button type="primary" size="mini" round @click="sharedetailnewDialog=true">分享详情信息</el-button>
          </el-col>
        </div>
        <el-table :data="showoffersinfos.goods">
	          <el-table-column label="品牌图片">
              <template slot-scope="scope">
                  <div style="float:left;width:10%;border:1px solid #dddddd;padding:2px;border-radius:5px">
                      <img :src="GLOBAL.staticUrl+scope.row.thumb"  style="float:left;width:100%;border-radius:5px"/>
                  </div>
              </template>
            </el-table-column>
            <el-table-column label="品牌名称" prop="name" width="120" align="center"></el-table-column>
        </el-table>
    </el-dialog>
    <!-- 活动信息详情 end -->

    <!-- 活动详情信息 start -->
    <el-dialog title="活动详情信息" :visible.sync="offersnewDialog" width="50%" top="10vh">
      <div class="offersnewct" style="float:left;width:100%" v-html="showoffersinfos.content"></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="offersnewDialog=false">取 消</el-button>
      </div>  
    </el-dialog>
    <!-- 活动详情信息 end -->

    <!-- 活动商品信息及下单情况 -->
    <el-dialog title="活动订单信息统计" :visible.sync="offersgoodsstatDialog" width="90%" top="10vh">
       <el-table :data="offersnewsgoods" v-loading="offersgoodsstatloading">
            <el-table-column label="下单次数" prop="orders"  align="center"></el-table-column>
            <el-table-column label="下单店铺数" prop="shops"  align="center"></el-table-column>
            <el-table-column label="下单人数" prop="users"  align="center"></el-table-column>
            <el-table-column label="实付金额" prop="prices"  align="center"></el-table-column>
            <el-table-column label="成本" prop="costs"  align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" circle icon="el-icon-search" @click="showgoodsorders(scope.row)"></el-button>
              </template>
            </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 活动商品信息及下单情况 -->

    <!-- 活动商品信息订单详情 -->
    <el-dialog title="订单信息详情" :visible.sync="showgoodsordersDialog" width="95%" top="10vh">
       <el-table :data="showgoodsorderslists" v-loading="showgoodsordersloading">
	          <el-table-column label="订单号" prop="ordernumber"></el-table-column>
            <el-table-column label="下单店铺" prop="shopname" width="200" align="center"></el-table-column>
            <el-table-column label="收货人" prop="truename" width="100" align="center"></el-table-column>
            <el-table-column label="收货电话" prop="phone" width="120" align="center"></el-table-column>
            <el-table-column label="实付小计" prop="prices" width="100" align="center"></el-table-column>
            <el-table-column label="成本" prop="cost" width="100" align="center"></el-table-column>
            <el-table-column label="付款时间" prop="paytime" width="180" align="center"></el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageoffersordersChange"
            @current-change="pageoffersordersCurrentChange"
            :current-page="showgoodsordersquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="showgoodsordersquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="showgoodsorders_row">
          </el-pagination>
          <!--分页end-->
        </div>
    </el-dialog>
    <!-- 活动商品信息订单详情 -->

    <!-- 分享设置 start-->
    <el-dialog title="活动分享信息设置" :visible.sync="addshareDialog" width="50%" top="10vh">
        <el-tag type="danger" size="min">温馨提示：请按照相关分享平台的规则来设置分享内容、字数、图片大小，以免分享后无法查看到设置内容</el-tag>
        <el-form :inline="true" style="margin-top:10px">
            <el-form-item label="分享图片" label-width="100" size="small" style="width:100%;">
                <template>
                  <div style="float:left;width:100px;border:1px dashed #ddd;border-radius:12px">
                    <input type="file" id="shareimg" style="display:none" @change="getshareaddimg($event)">
                    <a style="float:left;width:100%;cursor:pointer" @click="getsharecontent">
                      <img :src="GLOBAL.staticUrl+addActivequery.share.img" v-if="addActivequery.share.img!=''" style="float:left;width:100%;border-radius:12px"/>
                      <img src="../../static/images/no-img.png" v-if="addActivequery.share.img==''" style="float:left;width:100%;border-radius:12px"/>
                    </a>
                  </div>
                </template>
      	    </el-form-item>
            <el-form-item label="分享标题" label-width="100" size="small" style="width:100%;">
                <el-input placeholder="请输入分享标题" v-model="addActivequery.share.title" clearable style="width:400px"></el-input>
      	    </el-form-item>
            <el-form-item label="分享内容" label-width="100" style="width:100%;">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10}" placeholder="请输入分享内容" v-model="addActivequery.share.content" style="width:400px" clearable></el-input>
      	    </el-form-item>
        </el-form>
    </el-dialog>


    <el-dialog title="活动分享信息" :visible.sync="sharedetailnewDialog" width="50%" top="10vh">
        <el-form :inline="true" style="margin-top:10px">
            <el-form-item label="分享图片" label-width="100" size="small" style="width:100%;">
                <template>
                  <div style="float:left;width:100px;border:1px dashed #ddd;border-radius:12px">
                      <img :src="GLOBAL.staticUrl+showoffersinfos.shareimg" v-if="showoffersinfos.shareimg!=''" style="float:left;width:100%;border-radius:12px"/>
                      <img src="../../static/images/no-img.png" v-if="showoffersinfos.shareimg==''" style="float:left;width:100%;border-radius:12px"/>
                  </div>
                </template>
      	    </el-form-item>
            <el-form-item label="分享标题" label-width="100" size="small" style="width:100%;">
                <template>
                  {{showoffersinfos.sharetitle}}
                </template>
     	      </el-form-item>
            <el-form-item label="分享内容" label-width="100" style="width:100%;">
                <template>
                  {{showoffersinfos.sharecontent}}
                </template>
      	    </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 分享设置 end-->

    <el-dialog title="设置活动可展示区域" :visible.sync="addareaDialog" width="50%" top="10vh">
        <el-tree 
            :data="citytrees" 
            ref="citytrees" 
            v-loading="addrealoading" 
            highlight-current 
            show-checkbox node-key="id" 
            @check="selectcityids"
        >
        </el-tree>
    </el-dialog>

    <el-dialog title="活动可展示区域" :visible.sync="offersareasDialog" width="50%" top="10vh">
        <div>{{showoffersinfos.citys}}</div>
    </el-dialog>


    <!-- 设置拼团信息 -->
    <el-dialog title="设置拼团信息" :visible.sync="pintuansettingDialog" width="35%" top="10vh">
        <el-tag type="danger" size="mini">警告：如选择拼团失败系统会将已拼团的订单全部标注为商家取消订单，且需要进行人工退款</el-tag>
        <el-form size="mini" style="margin-top:10px">
          <el-form-item>
              <el-select v-model="pintuansettingquery.status" placeholder="请选择类型" filterable>
              	  <el-option v-for="item in pintuanstatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
              <el-input type="textarea" v-model="pintuansettingquery.reason" placeholder="请填写成团失败原因" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="offersnewDialog=false">取 消</el-button>
            <el-button type="primary" size="small" @click="changestatus">保 存</el-button>
        </div>  
    </el-dialog>


           
  </div>
  </transition>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import  QrcodeVue  from 'qrcode.vue'

export default {
  components: {
    quillEditor,
    QrcodeVue,
  },
  data () {
    return {
        url:this.GLOBAL.domain+"Offers/index",
        transitionshow:true,
        actionauth:'', //功能权限
        isselect:false,
        listLoading:false,
        query: {
          act:'getofferspintuanlists',
	        token:this.$cookies.get('token'),
          date:[],
          status:'',
          p:1,
          keytype:1,
          key:'',
          rollpage:10
        },
        datalists:[],
        stattotals:{
          orders:0,
          shops:0,
          users:0,
          amounts:0,
          costs:0
        },
        total_rows:100,
        statuslists:[
          {id:1,name:'未开团'},
          {id:2,name:'已开团'},
          {id:3,name:'成团失败'},
        ],
        keytypelists:[
          {id:1,name:'按活动名称搜索关键字'},
          {id:2,name:'按品牌名称搜索关键字'},
        ],

        iswarningclose:true,
        addactiveDialog:false,
        addActivequery: {
          act:'addofferspintuan',
          token:this.$cookies.get('token'),
          id:'',
          name:'',
          thumb:[],
          content:'',
          share:{
            img:'',
            title:'',
            content:'',
          },
          showdate:[],
          date:[],
          amount:'',
          singleamount:'',
          limitpercent:'',
          placepercent:'',
          brands:[],
          citylists:[],
        },
        addareaDialog:false,
        addrealoading:false,
        citytrees:[],
        addActivequeryloading:false,
        addoffersnewLoading:false,
        addcontentDialog:false,
        goodsDialog:false,
        goodsqueryischange:false,
        isjdshow:false,
        saleagents:[],
        datafrom:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
        groundings:[
          {id:1,name:'未上架'},
          {id:2,name:'已上架'}
        ],
        brandlists:[],
        goodsquery: {
          act:'getoffersbrands',
          token:this.$cookies.get('token'),
          ids:[],
          key:'',
          p:1,
          rollpage:10,
        },
        goodslistsloading:false,
        goodslists:[],
        goods_rows:0,
        selectpropertyids:[],
        selectgoods:[],
        propertyDialog:false,
        propertyloading:false,
        propertyquery: {
          act:'getgoodsproperty',
          token:this.$cookies.get('token'),
          index:'',
          goodsid:''
        },
        propertylists:[],
        showoffersDialog:false,
        showoffersloaing:false,
        showoffersinfos:'',
        offersnewDialog:false,
        offersgoodsstatDialog:false,
        offersgoodsstatloading:false,
        offersnewsgoods:[],
        showgoodsordersDialog:false,
        showgoodsordersloading:false,
        showgoodsorderslists:[],
        showgoodsordersquery: {
          act:'getofferspintuanorders',
          token:this.$cookies.get('token'),
          id:'',
          goodstype:'',
          p:1,
          rollpage:10
        },
        showgoodsorders_row:0,
        addshareDialog:false,
        sharedetailnewDialog:false,
        shareimg:'',
        sharetitle:'',
        sharecontent:'',
        offersareasDialog:false,
        pintuanstatus:[
          {id:1,name:'开团'},
          {id:2,name:'拼团失败'},
        ],
        pintuansettingDialog:false,
        pintuansettingquery: {
            act:'changeofferstatus',
            token:this.$cookies.get('token'),
            id:'',
            status:'',
            reason:'',
            loading:false,
        },
        
        editorOption: { //文本框功能配置
		        placeholder: '请输入内容',
		        modules: { // 配置富文本
			        toolbar: {
				        container: [
					        ['bold', 'italic', 'underline', 'strike'],
                  ['blockquote', 'code-block'],
                  [{ 'header': 1 }, { 'header': 2 }],
                  [{ 'direction': 'rtl' }],
                  [{ 'size': ['small', false, 'large', 'huge'] }],
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'font': [] }],
                  //['image']
				        ],
                handlers: {
                  'image': function(value) {
                      if(value) {
                          document.querySelector('.addoffersfile').click();
                      }else {
                          this.quill.format('image', false);
                      }
                  }
                },
			        },
		        }
	      },

        changebrandindex:'',
        
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getList(); //获取活动信息
  },
  
  methods:{
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },


    /** 获取活动信息 **/
    getList() {
      if(this.isselect) {
        this.query.p=1;
        this.query.rollpage=10;
      }

      this.listLoading=true;
      var resource = this.$resource(this.url);
	    resource.save(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
            this.listLoading = false;
		    }else{
		        this.datalists = JSON.parse(Base64.decode(res.data.Data));
            this.total_rows=parseInt(res.data.count);
            this.listLoading = false;
            if(this.isselect) this.isselect=false;
            this.getstattotals();
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
          this.listLoading = false;
	    });
    },

    /** 统计商品小计信息 **/
    getstattotals() {
        this.stattotals.orders=0;
        this.stattotals.shops=0;
        this.stattotals.users=0;
        this.stattotals.amounts=0;
        this.stattotals.costs=0;
        let statquery={
          act:'getofferspintuanstats',
          token:this.query.token,
          date:this.query.date,
          status:this.query.status,
          keytype:this.query.keytype,
          key:this.query.key
        };

        var resource = this.$resource(this.url);
        resource.save(statquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.stattotals.orders=result.orders;
              this.stattotals.shops=result.shops;
              this.stattotals.users=result.users;
              this.stattotals.amounts=result.prices;
              this.stattotals.costs=result.costs;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    //删除活动信息
    deloffersnew(item) {
      this.$confirm('您是否确定要删除该活动？', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save({act:'delofferspintuan',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.getList();
            }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      }).catch(() => {
            
      });    
    },

    //获取活动详情信息
    showactives(item) {
      this.showoffersDialog=true;
      this.showoffersloaing=true;
      this.showoffersinfos='';

      var resource = this.$resource(this.url);
      resource.save({act:'getofferspintuaninfo',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.showoffersloaing=false;
          }else{
              this.showoffersinfos=JSON.parse(Base64.decode(res.data.Data));
              this.showoffersloaing=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.showoffersloaing=false;
      });
    },


    //基础信息
    ///////////////////////////////////////////////////
    //获取代理商列表
    getagents() {
      var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	    resource.query({act:'getsaleagents',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        this.saleagents = JSON.parse(Base64.decode(res.data.Data));
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
    },

    //获取代理商是否有京东商品权限
    getJDshow() {
		  var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	    resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.isjdshow=result.show;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	  },

    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:1000000}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    //////////////////////////////////////////////////

  
  	/** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
      this.actionauth=data;
    },

    /** 关闭提示 **/
    closenotice() {
      this.iswarningclose=false;
    },

    /** 添加活动 **/
    addoffers() {
      this.addActivequery.act='addofferspintuan';
      this.addActivequery.id='';
      this.addActivequery.name='';
      this.addActivequery.thumb=[];
      this.addActivequery.content='';
      this.addActivequery.share.img='';
      this.addActivequery.share.title='';
      this.addActivequery.share.content='';
      this.addActivequery.showdate=[];
      this.addActivequery.date=[];
      this.addActivequery.amount='';
      this.addActivequery.singleamount='';
      this.addActivequery.limitpercent='';
      this.addActivequery.brands=[];
      this.addActivequery.citylists=[];
      this.addactiveDialog=true;
    },

    /** 关闭添加活动窗口信息前 **/
    closeadd() {
      this.$confirm('温馨提示：关闭当前活动添加/编辑页会导致已填写的数据丢失，您是否确定要关闭？', { type: 'warning' }).then(() => {
         this.addactiveDialog=false;
      }).catch(() => {
         this.addactiveDialog=true;
      });   
    },

    /** 打开/关闭是否限购按钮 **/
    changeaddoffersnew(val,index) {
      if(!val) this.addActivequery.goods[index].limitnums=0;
    },

    /** 删除已选中的商品信息 **/
    deladdoffersgoods(index) {
      this.$delete(this.addActivequery.brands,index);
    },

    /** 删除全部已选的商品信息 **/
    deladdoffersall() {
      this.$confirm('您是否确定要清空已选的商品？', { type: 'warning' }).then(() => {
          this.addActivequery.brands=[];
      }).catch(() => {
            
      });    	
    },

    /** 提取图片信息 **/
    getaddimg(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    }else {
            data.imgsrc=this.GLOBAL.staticUrl+data.imgsrc;
            let quill = this.$refs.myQuillEditor.quill;
            // 获取光标所在位置
			      let length = quill.getSelection().index;
			      // 插入图片  res.info为服务器返回的图片地址
			      quill.insertEmbed(length, 'image', data.imgsrc)
			      // 调整光标到最后
			      quill.setSelection(length + 1);
            obj.target.value = '';  
	        }
	    }).catch((res) => {
	        
	    });
      document.querySelector('.addoffersfile').val=null;
    },


    ///////////////////////////////////////////////////////////////////////////////////////
    //获取商品信息
    checkgoods() {
        let _this=this;
        this.goodsDialog=true;
        this.goodsquery.key='';
        this.goodsquery.p=1;
        this.goodsquery.rollpage=10;
        this.selectgoods=[];
        this.goodsquery.ids=[];
        this.addActivequery.brands.forEach(function(item,i) {
            _this.selectgoods.push(item);
            _this.goodsquery.ids.push(item.id);
        });
        this.getgoodsList();
    },

    //获取商品信息
    getgoodsList() {
        this.goodslistsloading=true;
        if(this.goodsqueryischange==true) {
            this.goodsquery.p=1;
            this.goodsquery.rollpage=10;
        }
        var resource = this.$resource(this.url);
        resource.save(this.goodsquery).then((res) => {      
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.goodslistsloading = false;
            }else{
                this.goodslists = JSON.parse(Base64.decode(res.data.Data));
                this.goods_rows=parseInt(res.data.count);
                this.goodslistsloading = false;
                if(this.goodsqueryischange==true) this.goodsqueryischange=false;
                //勾选已选中的商品信息
                let _this=this;
                var ids=[];
                this.selectgoods.forEach(function(e,index) {ids.push(e.id);});
                setTimeout(function() {
                    _this.goodslists.forEach(function(e,i) {
                        ids.indexOf(e.id) > -1 ? _this.$refs.multipleTable.toggleRowSelection(e) : '';
                    });
                },200);
          
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.goodslistsloading=false;
        });
    },

    pageChoosegoodsChange(val) {
        this.goodsquery.rollpage = val;
        this.getgoodsList();
    },
    pageChoosegoodsCurrentChange(val) {
        this.goodsquery.p = val;
        this.getgoodsList();
    },

    //点击单行选择商品信息
    rowclick(val,row) {
        this.$refs.multipleTable.toggleRowSelection(val);
        var number=-1;
        var _this=this;
        this.selectgoods.forEach(function(e,index) {
            if(e.id==val.id) number=index;
        });
        number==-1 ? this.selectgoods.push({id:val.id,name:val.name,brandid:val.brandid,isshowmall:val.isshowmall}) : this.$delete(this.selectgoods,number);
    },

    //点击勾选信息
    handleSelectsingle(val,row) {
        var number=-1;
        var _this=this;
        this.selectgoods.forEach(function(e,index) {
            if(e.id==row.id) number=index;
        });
        number==-1 ? this.selectgoods.push({id:row.id,name:row.name,brandid:row.brandid,isshowmall:row.isshowmall}) : this.$delete(this.selectgoods,number);
    },

    //点击全选商品信息
    handleSelectall(val) {
        var _this=this;
        if(val.length > 0) { //全选商品
            var number=-1;
            this.goodslists.forEach(function(e,i) {
                number=-1;
                _this.selectgoods.forEach(function(ee,ii) {
                    if(e.id==ee.id) number=ii;
                });
                _this.selectgoods.push({id:e.id,name:e.name,brandid:e.brandid,isshowmall:e.isshowmall});
            });

        }else { //取消全选商品
            var number=-1;
            this.goodslists.forEach(function(e,i) {
                number=-1;
                _this.selectgoods.forEach(function(ee,ii) {
                    if(e.id==ee.id) number=ii;
                });
                _this.$delete(_this.selectgoods,number);
            });
        }
    },

    //修改商品规格信息
    changeproperty(item,index) {
      this.propertylists=[];
      this.propertyquery.index=index;
      this.propertyquery.goodsid=item.goodsid;
      this.propertyDialog=true;
      this.propertyloading=true;

      var resource = this.$resource(this.url);
      resource.save(this.propertyquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.propertyloading = false;
        }else{
          this.propertylists = JSON.parse(Base64.decode(res.data.Data));
          this.propertyloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.propertyloading=false;
      });
    },

    //确认选择商品规格信息
    selectpropertys(item) {
      let index=this.propertyquery.index;
      let _this=this;
      let istrue=false;

      if(this.addActivequery.goods[index].propertyid==item.id) { //规格已存在的无需处理
          this.propertyDialog=false;
      }else {
          _this.addActivequery.goods.forEach(function(t,i) {
              if(i!=index && t.propertyid==item.id) istrue=true;
          });
          if(istrue) { //商品规格已存在，抛出错误，不允许添加
              this.$message.error("该规格信息已被添加到商品列表中");
          }else { //商品规格信息不存在，正常修改
              this.addActivequery.goods[index].propertyid=item.id;
              this.addActivequery.goods[index].spec=item.spec;
              this.addActivequery.goods[index].type=item.type==0 ? 1 : 2;
              this.addActivequery.goods[index].agentname=item.agentname;
              this.propertyDialog=false;
          }
      }

    },

    //添加已选中的商品信息
    addgoodssave_old() {
      let _this=this;
      let ids=[];
      this.addActivequery.brands.forEach(function(e,index) {ids.push(e.id)});
      //获取已选中的品牌信息
      this.selectgoods.forEach(function(e,i) {
          ids.indexOf(e.id)==-1 ? _this.addActivequery.brands.push(e) : '';
      });

      this.goodsDialog=false;
    },

    //添加已经选中的品牌信息
    addgoodssave(item) {
      this.addActivequery.brands=[];
      this.addActivequery.brands.push(item);
      this.goodsDialog=false;
    },


    //保存活动信息
    addcreateSave() {
        this.addoffersnewLoading=true;
        var resource = this.$resource(this.url);
        resource.save(this.addActivequery).then((res) => {      
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.addoffersnewLoading = false;
            }else{
                this.addoffersnewLoading = false;
                this.addactiveDialog=false;
                this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addoffersnewLoading=false;
        });
    },
    ////////////////////////////////////////////////////////////////////////////////////////

    //获取商品下单信息统计
    getorderstats(obj) {
      this.offersgoodsstatDialog=true;
      this.offersgoodsstatloading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'getpintuanorderstat',token:this.$cookies.get('token'),id:obj.id}).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.offersgoodsstatloading = false;
        }else{
          this.offersnewsgoods = JSON.parse(Base64.decode(res.data.Data));
          this.offersgoodsstatloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.offersgoodsstatloading=false;
      });
    },

    //获取活动商品所下订单数据信息
    showgoodsorders(item) {
      this.showgoodsordersDialog=true;
      this.showgoodsordersquery.p=1;
      this.showgoodsordersquery.rollpage=10;
      this.showgoodsordersquery.id=item.id;
      this.showgoodsordersquery.goodstype=item.goodstype;
      this.getshowgoodsorders();
    },

    //获取订单详情数据
    getshowgoodsorders() {
      this.showgoodsordersloading=true;
      var resource = this.$resource(this.url);
      resource.save(this.showgoodsordersquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.showgoodsordersloading = false;
        }else{
          this.showgoodsorderslists = JSON.parse(Base64.decode(res.data.Data));
          this.showgoodsorders_row=parseInt(res.data.count);
          this.showgoodsordersloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.showgoodsordersloading=false;
      });
    },

    pageoffersordersChange(val) {
        this.showgoodsordersquery.rollpage = val;
        this.getshowgoodsorders();
    },
    pageoffersordersCurrentChange(val) {
        this.showgoodsordersquery.p = val;
        this.getshowgoodsorders();
    },

    /** 获取编辑活动信息 **/
    editoffersnew(item) {
      this.addactiveDialog=true;
      this.addActivequeryloading=true;

      var resource = this.$resource(this.url);
      resource.save({act:'geteditofferspintuan',token:this.$cookies.get('token'),id:item.id}).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addActivequeryloading = false;
        }else{
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.addActivequery.act='editofferspintuan';
          this.addActivequery.id=item.id;
          this.addActivequery.name=result.name;
          this.addActivequery.thumb=[];
          this.addActivequery.thumb=result.thumb;
          this.addActivequery.content=result.content;
          this.addActivequery.date=result.date;
          this.addActivequery.showdate=result.showdate;
          this.addActivequery.amount=result.amount;
          this.addActivequery.singleamount=result.singleamount;
          this.addActivequery.limitpercent=result.limitpercent;
          this.addActivequery.placepercent=result.placepercent;
          this.addActivequery.brands=[];
          this.addActivequery.citylists=[];
          this.addActivequery.citylists=result.citys;
          this.addActivequery.brands=result.brands;
          this.addActivequery.share.img=result.shareimg;
          this.addActivequery.share.title=result.sharetitle;
          this.addActivequery.share.content=result.sharecontent;
          this.addActivequeryloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addActivequeryloading=false;
      });
    },


    /** 点击上传活动图片信息 **/
    getadimga() {
        //if(this.addActivequery.thumb.length==4) {this.$message.error("活动最多只能上传4张宣传图片");return false;}
        document.getElementById('adimg').click();
    },

    //上传图片
    getadimgb(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	  this.$message.error(data.msg);
		    }else {
            this.addActivequery.thumb.push(data.imgsrc);
            obj.target.value = '';  
	      }

	    }).catch((res) => {
	        
	    });
    },

	  //删除图片
	  closethumb(index) {
		    this.$delete(this.addActivequery.thumb,index);
	  },


    //设置活动区域
    settingareas() {
      this.addareaDialog=true;
      this.addrealoading=true;

      var resource = this.$resource(this.url);
      resource.save({act:'getofferspintuanarea',token:this.$cookies.get('token')}).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addrealoading = false;
        }else{
          this.citytrees = JSON.parse(Base64.decode(res.data.Data));
          let ids=[];
          this.addActivequery.citylists.forEach(function(e,i) {ids.push(e)});
          this.$refs.citytrees.setCheckedKeys(ids);
          this.addrealoading=false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addrealoading=false;
      });
    },

    //点击复选框选择城市
    selectcityids() {
      this.addActivequery.citylists=[];
      this.addActivequery.citylists=this.$refs.citytrees.getCheckedKeys();
    },


    /*** 设置分享内容 ***/
    getsharecontent() {
      document.getElementById('shareimg').click();
    },
    getshareaddimg(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    }else {
            this.addActivequery.share.img=data.imgsrc;
            obj.target.value = '';  
	        }
	    }).catch((res) => {
	        
	    });
    },
    /*** 设置分享内容 **/


    /** 设置拼团信息 **/
    getpingtuansetting(item) {
      this.pintuansettingquery.id=item.id;
      this.pintuansettingquery.status='';
      this.pintuansettingquery.reason="";
      this.pintuansettingDialog=true;
    },

    /** 活动开团 **/
    changestatus(item) {
        var resource = this.$resource(this.url);
        resource.save(this.pintuansettingquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.pintuansettingDialog=false;
                this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        }); 
    },


    changebrandthumb(item) {
        document.getElementById('brandimg').click();
    },

    //上传图片
    getadimgbrand(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	  this.$message.error(data.msg);
		    }else {
            this.addActivequery.brands[0].thumb=data.imgsrc;
            obj.target.value = '';  
	      }

	    }).catch((res) => {
	        
	    });
    },

  }
}
</script>
<style>
.backborder1s {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder2s {background:rgba(211, 211, 211, 0.6);border-radius:15px;border:1px solid #ddd;min-height:70px;overflow:hidden;transition:.36s all}
.backborder2s .content {float:left;width:95%;font-size:12px;}
.backborder2s .content ul {margin:0;padding:0}
.backborder2s .content li {float:left;width:100%;list-style-type:none;line-height:18px;color:red;margin-top:5px}
.backborder2s .close {float:right;width:5%}
.backborder2s .close .el-button--mini.is-circle {padding:5px;margin-top:50px}
.closenotice {display:none}
.backbbtn .el-button--mini.is-circle {margin:0}

.activetotal {float:left;margin-right:3%;color:#8b572a;font-size:13px;font-weight:550}
.offermoney i {float:left;font-style:normal;font-size:12px;margin-right:5px;background:#E6A23C;color:#fff;padding:5px 10px;line-height:12px;border-radius:15px;margin-top:5px}
.offermoney span {float:left;font-size:12px;margin-top:5px;color:#8b572a;font-weight:600}
.offertime i {float:left;font-style:normal;font-size:12px;margin-right:5px;background:#409EFF;color:#fff;padding:5px 10px;line-height:12px;border-radius:15px;margin-top:5px}
.offertime span {float:left;font-size:12px;margin-top:5px;color:#666}
.offertitles span {float:left;margin-right:10px;max-width:70%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.offerstatus1 {float:left;font-style:normal;font-size:10px;background:rgba(144,147,153,.1);border-color:rgba(144,147,153,.2);border:1px solid;color:#909399;border-radius:15px;padding:3px;line-height:10px;margin-top:3px}
.offerstatus2 {float:left;font-style:normal;font-size:10px;background:rgba(103,194,58,.1);border-color:rgba(103,194,58,.2);border:1px solid;color:#67c23a;border-radius:15px;padding:3px;line-height:10px;margin-top:3px}

.addoffersnew .el-form-item {margin-bottom:12px}

.offersnewgoods {float:left;width:90%;padding:0 5%;margin:20px 0 60px 0}
.offersgoodsshow {float:left;width:100%;border-bottom:1px dashed #ddd;line-height:14px}
.offersnewgoods p {float:left;font-size:14px;font-weight:bold;}
.showoffersgoods {float:left;width:100%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap}
.showoffersgoodsspec {float:left;margin-top:5px;width:100%;font-size:12px;color:#999999;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.showoffersgoodsspec a {float:left;padding:5px 2px;line-height:12px;border:1px dashed #999999;border-radius:5px;cursor:pointer}
.showoffersgoodsspec a:hover {background:rgb(255,209,0,.6);border-color:rgb(255,209,0,.9);color:#333336}
.showoffersgoodsagent {float:left;margin-right:10px;font-size:12px;line-height:12px;background:#e6a23c;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}
.showoffersgoodscz {float:left;font-size:12px;line-height:12px;background:#67c23a;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}
.showoffersgoodsjd {float:left;font-size:12px;line-height:12px;background:#f56c6c;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}


.offersnewgoods {float:left;width:100%;padding:10px;}
.offersallsetting {float:left;margin-left:2%;line-height:13px}
.offersallsetting p {float:left;font-size:13px;color:#8b572a;line-height:14px;margin-top:7px;padding:5px}
.offersallsetting p em {font-style:normal;font-size:15px;font-weight:bold}
.offersnewct img {float:left;max-width:100%}

.backborder-other {background:#fff;float:left;width:98%;padding:0 1%;}
.backborder-other .imglists {float:left;width:100%;padding:0;margin:0 0 10px 0}
.backborder-other .imglists li {float:left;height:70px;padding:1px;border-radius:5px;border:1px solid #dddddd;margin:0 1% 20px 0;list-style-type:none;padding:2px;border-radius:5px}
.backborder-other .imglists li a {cursor:pointer}
.backborder-other .imglists li img {float:left;height:70px;border-radius:5px}
.backborder-other .thumbclose {color:#fff;font-weight:bold;padding:5px;border-radius:50%;background:#F56C6C;padding:8px 5px;font-size:14px;line-height:2px;position:absolute;margin:-1px 0 0 -10px}
.pintuanpercent {float:left;height:15px;background:#E6A23C;border-radius:15px;margin:0;padding:0}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offerspintuan.vue